module.exports = __webpack_public_path__ + "img/chanp.37656097.png";